export default async function httpRequest(
  mehtod = "GET",
  url = "",
  params = {
    body: {},
    headers: {
      "Content-Type": "application/json",
    },
  }
) {
  let xhr = new XMLHttpRequest();
  xhr.open(mehtod, url);
  if (params.headers && Object.entries(params.headers).length) {
    for (const [key, value] of Object.entries(params.headers)) {
      xhr.setRequestHeader(String(key), value);
    }
  }

  return await new Promise((resolve, reject) => {
    xhr.onload = function () {
      if (xhr.readyState == 4) {
        if (xhr.responseText) {
          return resolve({
            status: xhr.status,
            data: xhr.responseText,
          });
        }
        return resolve({
          status: xhr.status,
          data: xhr.responseText,
        });
      }
    };
    xhr.send(JSON.stringify(params.body));
  });
}
